// Subscription store module - dispatches subscription API calls with planId
import * as SubscriptionApi from '@/api/subscription'

const state = {}

const getters = {}

const actions = {
  pauseSubscription ({commit}, data) {
    return SubscriptionApi.pauseSubscription(data.id, data.reason)
  },

  resumeSubscription ({commit}, data) {
    return SubscriptionApi.resumeSubscription(data.id)
  },

  cancelSubscription ({commit}, data) {
    return SubscriptionApi.cancelSubscription(data.id, data.reason)
  },

  undoCancellation ({commit}, data) {
    return SubscriptionApi.undoCancellation(data.id)
  },

  updateSubscription ({commit}, data) {
    return SubscriptionApi.updateSubscription(data.id, data.params)
  },

  listInvoicesBySource ({commit}) {
    return SubscriptionApi.listInvoicesBySource()
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
